<template>
  <div class="page500">
    <div class="systemError">
      <p class="lead">
        <strong>システムの問題が発生しました。</strong>
      </p>
      <p>
        <span>ブラウザの戻るボタンから</span
        ><span>前のページにお戻りいただき、</span><br class="hiddenSp" />
        <span>しばらく経ってから</span><span>再表示してください。</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SystemError'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.page500 {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.systemError {
  padding-left: 36px;
  padding-right: 36px;
  text-align: center;

  @include mixins.media() {
    width: 712px;
    background-color: #fff;
    position: relative;
  }

  span {
    display: inline-block;
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  &::before {
    content: '';
    display: block;
    width: 100px;
    height: 100px;
    margin: 0 auto 10px;
    background: url('~@/assets/images/icon/caution.svg') no-repeat;
    background-size: 100% 100%;

    @include mixins.media() {
      margin-bottom: 20px;
    }
  }

  > strong {
    font-weight: inherit;
  }

  & + p {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 20px;
    }
  }
}
</style>
